import { render } from "./CommentUserProfileContent.vue?vue&type=template&id=d4580804"
import script from "./CommentUserProfileContent.vue?vue&type=script&lang=js"
export * from "./CommentUserProfileContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__